export function _setupMenuIcon(state, navLinks, menuButtonElement) {
  menuButtonElement.addEventListener('click', () => {
    const toggleHiddenOff = () => {
      navLinks.classList.add('hidden');
    };

    if(!state.menuVisible) {
      state.menuVisible = true;
      menuButtonElement.removeEventListener('animationend', toggleHiddenOff);
      navLinks.classList.remove('hidden');
    } else {
      state.menuVisible = false;
      menuButtonElement.addEventListener('animationend', toggleHiddenOff);
    }
  });
}

export function setupMenuIcon(menuButtonElement) {
  const state = { menuVisible: false };
  return _setupMenuIcon(state, document.querySelector('.nav-links'), menuButtonElement)
};

export default setupMenuIcon;